import generalSection from "../_section/section.class";
import {userGiftCertificateUpload, adminGiftCertificateUpload} from "./upload";
import DataForm from "./DataForm";
import problem from "../_section/section-problem.class";
import ApplicationForm from "./ApplicationForm";
import {Figures} from "./Figures";
export class userGiftCertificateSection extends generalSection {
    constructor(request, mortgage, props, statementUploadFactory = null) {
        super(request, mortgage, props, statementUploadFactory ?? userGiftCertificateUpload);
        // Add missing date error

    }
}

export class adminGiftCertificateSection extends userGiftCertificateSection {
    constructor(request, mortgage, props) {
        super(request, mortgage, props, adminGiftCertificateUpload);
        this.DataForm = DataForm
        this.ApplicationForm = ApplicationForm
        this.sortByDateProp('documentDate');
        this.activeUploads = this.uploads.filter(u=> u.allValuesAnswered && u.isVerifiable && u.isActive)
        this.setProblems(this.getProblems())
    }

    Figures(){
        return new Figures({section: this});
    }

    get sumOfActiveUploads(){
        const sum = this.activeUploads.reduce( (acc, upload) => {

            if (upload.values.amount) {
                return acc + parseFloat(upload?.values?.amount||0);
            }
            return acc;
        },0)
        return sum
    }
    getProblems (){
        const problems =  this.problemsList.singleUploadUserProblems();
        if (!problems.length){

            const sum = this.sumOfActiveUploads
            // Amount Mismatch
            const applicationAmount = this.mortgage.requirement.depositGifts
            if (sum && applicationAmount && sum !== applicationAmount) {
                problems.push(new problem({
                    type: 'BUNDLE',
                    title: 'Data Mismatch',
                    reason: 'Application amount doesnt match the upload',
                    uploadIDs: this.activeUploads.map(u => u.id),
                    message: `${sum} does not match the application amount (${applicationAmount})`,
                }))
            }
        }
        return problems
    }
    get documentDate() {
        if (this.activeUpload && this.activeUpload.values.documentDate) {
            return this.activeUpload.values.documentDate;
        }
        return null;
    }
    get gifterNames() {
        if (this.activeUpload && this.activeUpload.values.gifterNames) {
            return this.activeUpload.values.gifterNames;
        }
        return null;
    }
    get amount() {
        if (this.activeUpload && this.activeUpload.values.amount) {
            return this.activeUpload.values.amount;
        }
        return null;
    }



}